
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BusinessProcessEntityService } from '../../../services/settings/businessprocess-entity.service';
import { IRequisitionEntityService } from '../../../interfaces/entities/requisition-entity-service-interface';
import { REQUISITION_ENTITY_SERVICE_TOKEN } from '../../../injection-tokens/entity-service-tokens';
import { RequisitionMovement } from '../../../models/entities/requisition-model';
import { LoginEntityService } from '../../../services/entity-services/login-entity.service';
import { Router } from '@angular/router';
import { Log, IShortLogger } from '../../../services/logger.service';

@Component({
  selector: 'app-forward-requisition',
  templateUrl: './forward-requisition.component.html',
  styleUrls: ['./forward-requisition.component.css']
})
export class ForwardRequisitionComponent implements OnInit {
  private readonly logger: IShortLogger<ForwardRequisitionComponent> = Log.create(ForwardRequisitionComponent);
  @Input() requisitionId?: string;
  @Input() selectedRequisition?: any;
  @Input() redirectNavigationUrl: any;
  @Output() closed = new EventEmitter<void>();
  @Output() forwarded = new EventEmitter<any>();

  /** Selected values — bound via [(ngModel)] in the template. */
  selectedActivity = '';
  selectedTeam = '';
  selectedUser = '';
  remarks = '';

  activities: any[] = [];
  teams: any[] = [];
  users: any[] = [];
  attachments: File[] = [];
  isSubmitting = false;

  /** True when all four fields have a non-empty value. */
  get isFormValid(): boolean {
    return !!(this.selectedActivity && this.selectedTeam && this.selectedUser && this.remarks?.trim());
  }

  constructor(
    private http: HttpClient,
    private loginEntityService: LoginEntityService,
    private businessProcessService: BusinessProcessEntityService,
    private snackBar: MatSnackBar,
    @Inject(REQUISITION_ENTITY_SERVICE_TOKEN) public requisitionService: IRequisitionEntityService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadActivities();
  }

  /** Called by (ngModelChange) on the activity select. Resets downstream selections. */
  onActivityChange(code: string): void {
    this.selectedTeam = '';
    this.selectedUser = '';
    this.teams = [];
    this.users = [];
    if (code) {
      this.loadTeams(code);
    }
  }

  /** Called by (ngModelChange) on the team select. Resets user selection. */
  onTeamChange(team: string): void {
    this.selectedUser = '';
    this.users = [];
    if (team) {
      this.userGetByTeam(team);
    }
  }

  loadActivities() {
    // this.http.get<any[]>('/api/activities').subscribe(res => this.activities = res);

    this.businessProcessService.getAllBusinessProcess().subscribe({
      next: (result: any[]) => {
        this.activities = result.find(bp => bp.name === 'Requisitions')?.activities || [];

        if (this.activities.length > 0) {
          this.activities = this.activities.filter(act => act.code.toLowerCase().trim() !== 'drafting');
        }
        this.logger.i('Loaded Activities :', this.activities);
      },
      error: (err: any) => {
        this.logger.e('Error loading Teams:', err);
      }
    });
  }

  // loadTeams() {
  //   this.http.get<any[]>('/api/teams').subscribe(res => this.teams = res);
  // }

  loadTeams(activityName: any): void {

    if (this.activities.filter(act => act.code === activityName).length == 0)
      return;

    if (this.activities.filter(act => act.code === activityName)[0].actions.length == 0) {
      return
    }
    const filteredTeams = this.activities.filter(act => act.code === activityName)[0].actions[0].rights.teams;
    this.teams = filteredTeams;
    //  this.activities.filter(act=>act.name===activity)?.actions[0].teams;
  }


  loadTeamsAll(): void {
    // For demo purposes, using sample data
    // Replace this with actual API call when ready:
    this.businessProcessService.getAllTeams().subscribe({
      next: (result: any[]) => {
        this.teams = result;
        this.logger.i('Loaded Team :', this.teams);
      },
      error: (err: any) => {
        this.logger.e('Error loading Teams:', err);
      }
    });

  }


  userGetByTeam(team: string): void {

    this.loginEntityService.usersGetByTeam(team).subscribe({
      next: (result: any) => {
        this.users = result;
        this.logger.i('Loaded Users Get by Team:', this.users);
      },
      error: (err: any) => {
        this.logger.e('Error loading Users Get By Team:', err);
      }
    });
  }


  onFileSelected(event: any) {
    if (event.target.files) {
      for (let file of event.target.files) {
        this.attachments.push(file);
      }
    }
  }

  removeAttachment(index: number) {
    this.attachments.splice(index, 1);
  }

  send(): void {
    if (!this.isFormValid) {
      return;
    }

    const objToTeamId = this.teams.find(t => t.team === this.selectedTeam)?.teamId ?? '';
    const objToUserId = this.users.find(u => u.name === this.selectedUser)?.id ?? '';

    const objFromUserId = localStorage.getItem('userId') || '';
    const objFromUserName = localStorage.getItem('userName') || '';
    const objFromTeamId = localStorage.getItem('teamId') || '';
    const objFromTeamName = localStorage.getItem('team') || '';

    const objPurpose = this.activities.find(u => u.code === this.selectedActivity)?.name ?? this.selectedActivity;

    this.logger.d('Preparing to forward requisition with data:', { req: this.selectedRequisition });

    const objRequisition: RequisitionMovement = {
      requisitionId: this.selectedRequisition.id as string,

      purpose: objPurpose,
      purposeCode: this.selectedActivity,

      forwardToTeam: this.selectedTeam,
      forwardToUser: this.selectedUser,

      forwardToTeamId: objToTeamId,
      forwardToUserId: objToUserId,

      forwardFromTeamId: objFromTeamId,
      forwardFromUserId: objFromUserId,

      forwardFromTeam: objFromTeamName,
      forwardFromUser: objFromUserName,

      remarks: this.remarks,

      forwardedOn: new Date(),
      isActive: true,
      isRead: false,
      isPurposeDone: false,
      readDate: null,
      srNo: 0


    };
    this.logger.i('Forwarding Requisition with data:', objRequisition);
    this.isSubmitting = true;
    this.requisitionService.forwardRequisition(objRequisition).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        this.snackBar.open('Requisition forwarded successfully.', 'OK', { duration: 4000 });
        this.forwarded.emit(res);
        this.closed.emit();
        if (this.redirectNavigationUrl) {
          this.router.navigate([this.redirectNavigationUrl]);
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        const msg = err?.error?.message ?? err?.message ?? 'Failed to forward requisition.';
        this.snackBar.open(msg, 'Dismiss', { duration: 5000 });
        this.logger.e('Forward failed:', err);
      }
    });
  }

  close() {

    this.closed.emit();
  }
}
